<template>
  <div>
    <div
      v-for="opt in options"
      :key="opt.value"
      class="checkbox"
    >
      <label>
        <input
          type="checkbox"
          :checked="isChecked(opt.value)"
          @change="checkOption(opt.value)"
        >
        {{ opt.text }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    checked: [],
  }),
  watch: {
    value(val) {
      if (val) {
        this.checked = val.map((f) => f);
      } else {
        this.checked = [];
      }
    },
  },
  methods: {
    isChecked(value) {
      return this.checked.indexOf(value) >= 0;
    },
    checkOption(value) {
      const i = this.checked.indexOf(value);
      if (i >= 0) {
        this.checked.splice(i, 1);
      } else {
        this.checked.push(value);
      }
      this.updateForm();
    },
    updateForm() {
      this.$emit('input', this.checked);
    },
  },
};
</script>

<style scoped>

</style>
